// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"uZ-z"};